import { defineComponent, h, PropType } from "vue";
import { SmallIconNames } from "@/components/Icons/icon-names";

export default defineComponent({
  name: "SelfIcon",
  props: {
    size: {
      type: Number as PropType<number>,
      default: 40,
    },
    name: {
      type: String as PropType<SmallIconNames>,
      required: true,
    },
  },
  setup(props) {
    return () =>
      h(
        "svg",
        {
          width: props.size,
          height: props.size,
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg",
        },
        [
          h("use", {
            href: `/assets/icons/${props.name}.svg#${props.name}`,
          }),
        ]
      );
  },
});
